import { combineReducers } from 'redux'

import { CurrentInstalledTemplateReducer } from 'apps/templates/slices/currentInstalledTemplate'
import { CurrentTemplateReducer } from 'apps/templates/slices/currentTemplate'
import { installedTemplatesReducer } from 'apps/templates/slices/installedTemplates'
import { templateInstallationsReducer } from 'apps/templates/slices/templateInstallations'
import { templatesListReducer } from 'apps/templates/slices/templatesList'

import draft from './draft'
import installation from './templateInstallation'

export default combineReducers({
  draft,
  list: templatesListReducer,
  installed: installedTemplatesReducer,
  currentInstalled: CurrentInstalledTemplateReducer,
  current: CurrentTemplateReducer,
  installation,
  templateInstallations: templateInstallationsReducer,
})
